import styled from 'styled-components';
import { H1, H2, H3, SectionParent } from './../../StyledComponents';

import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import dedicated from '../../../assets/v2/Partner/dedicated.svg';
import marketing from '../../../assets/v2/Partner/co-marketing.svg';
import joint from '../../../assets/v2/Partner/joint.svg';
import Lead from '../../../assets/v2/Partner/Lead.svg';
import prerelease from '../../../assets/v2/Partner/prerelease.svg';
import promotion from '../../../assets/v2/Partner/promotion.svg';
import support from '../../../assets/v2/Partner/support.svg';
import validation from '../../../assets/v2/Partner/validation.svg';
import virtual from '../../../assets/v2/Partner/virtual.svg';

import { navigate } from '@reach/router';
require('./pricing.scss');

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #f9fbfe;
  padding: 96px 0 58px !important;
  background-size: contain;
  @media (max-width: 768px) {
    // padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    // padding-top: 2rem !important;
    /* padding-bottom: 5rem !important; */
  }
  width: 100%;
  display: grid;
  justify-items: center;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(15, 1fr);
  margin-top: 2rem;
  border-radius: 4px;
  width: 100%;
  // margin-bottom: 1rem;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 768px) {
    /* grid-template-columns: repeat(2, 1fr); */
    padding: 2rem;
    width: 100%;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2.5rem;
    padding-right: 2rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 3;
  border-radius: 5px;
  //   width: 200px;
  @media (max-width: 1100px) {
    max-width: 100%;
    margin-bottom: 2rem;
    grid-column: span 2;
  }
`;

const BottomWrapper = styled.div`
  display: grid;
  grid-column: span 15;
  grid-template-columns: repeat(16, 1fr);
  width: 80%;
  justify-self: center;
  @media (max-width: 1024px) {
    grid-column: span 4;
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 520px) {
    grid-column: span 2;
    grid-template-columns: repeat(2, 1fr);
  }
`;
const GridItemBottom = styled.div`
  grid-column: span 4;
  justify-self: center;
  border-radius: 5px;
  max-width: 100%;
  margin-top: 2rem;
  @media (max-width: 1024px) {
    grid-column: span 2;
    margin-top: 0;
    // justify-self: start !important;
    padding-left: 0 !important;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    justify-self: center !important;
    margin-bottom: 2rem;
  }
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center !important;
  color: #9095ab;
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;
const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 768px) {
    justify-items: center;
  }
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: start;
  justify-items: center;
  //   padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
`;
const TextWrapper = styled.div`
  display: grid;
  grid-column: span 2;
  @media (max-width: 768px) {
    // margin-left: -1rem;
  }
  @media (max-width: 350px) {
    margin-left: 0;
  }
`;

const HeroTitle = styled(H1)`
  // color: #ffffff;
  font-weight: bold;
  margin-bottom: 0;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
    padding: 1rem 2rem;
  }
`;

const HeroSubTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4f5263;
  text-align: center;
  padding: 2rem;
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;
const HeroSubTitleText = styled.div`
  font-size: 18px;
  padding: 0 0 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;
  text-align: center;
  @media (max-width: 520px) {
    padding: 1rem 2rem;
  }
`;
const StyledImg = styled(LazyLoadImage)`
  height: 46px;
  @media (max-width: 768px) {
    height: 56px;
  }
`;
const TitlesContainer = styled.div`
  @media (max-width: 768px) {
    text-align: left;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  height: 48px;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4f5263;

  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: normal;
    margin-top: 0.5rem;
  }
`;

const BottomContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-top: 4rem;
`;

const BottomBanner = styled.div`
  display: grid;
  border-radius: 8px;
  border: solid 1px #9095ab;
  background-color: #ffffff;
  grid-column: span 1;
  /* justify-self: end; */
  padding: 2rem;
  margin-left: 2rem;
  color: #735dbe;
  cursor: pointer;
  :hover {
    animation-name: example;
    animation-duration: 0.1s;
    box-shadow: 0 8px 18px 0 rgba(72, 82, 108, 0.19);
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    @keyframes example {
      /* 0% {
        background-color: #ffffff;
      } */
      100% {
        background-color: #735dbe;
      }
    }
  }
  @media (max-width: 520px) {
    grid-column: span 2;
    margin-left: 0;
    margin-bottom: 2rem;
  }
`;

const BottomBannerImage = styled.div`
  display: grid;
  justify-content: center;
  padding-bottom: 1rem;
`;

const BottomBannerText = styled.div`
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
`;
export default class PricingSectionTwo extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      hover1: false,
      hover2: false,
    };
  }
  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <HeroTitle>What Esper Brings to the Partnership</HeroTitle>
          <HeroSubTitle>
            Joining is easy. We handle testing, validation, and use case
            discovery.
          </HeroSubTitle>
          <HeroSubTitleText style={{ maxWidth: '565px' }}>
            We provide increasing levels of one-to-one support on strategy and
            marketing as we uncover potential in our partner relationships.
          </HeroSubTitleText>
          <GridContainer style={{ maxWidth: '920px' }}>
            <GridItem>
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={joint} />
                    </ImgWrapper>
                  </TitlesContainer>
                  <GridItemContent>
                    <GridTitle>
                      Joint Go-to-Market
                      <br />
                      Strategies{' '}
                    </GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={Lead} />
                    </ImgWrapper>
                  </TitlesContainer>
                  <GridItemContent>
                    <GridTitle>Lead Sharing</GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={marketing} />
                    </ImgWrapper>
                  </TitlesContainer>

                  <GridItemContent>
                    <GridTitle>
                      Co-Marketing <br />
                      Opportunities
                    </GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={dedicated} />
                    </ImgWrapper>
                  </TitlesContainer>
                  <GridItemContent>
                    <GridTitle>
                      Dedicated Platform <br />& Experience Teams{' '}
                    </GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <GridItem>
              {' '}
              <InnerContainer>
                <TextWrapper>
                  <TitlesContainer>
                    <ImgWrapper>
                      <StyledImg src={support} />
                    </ImgWrapper>
                  </TitlesContainer>
                  <GridItemContent>
                    <GridTitle>
                      Dedicated Partner <br />
                      Support
                    </GridTitle>
                  </GridItemContent>
                </TextWrapper>
              </InnerContainer>
            </GridItem>
            <BottomWrapper>
              <GridItemBottom>
                <InnerContainer>
                  <TextWrapper>
                    <TitlesContainer>
                      <ImgWrapper>
                        <StyledImg src={promotion} />
                      </ImgWrapper>
                    </TitlesContainer>
                    <GridItemContent>
                      <GridTitle>
                        Promotion on Esper <br />
                        Digital Properties
                      </GridTitle>
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
              <GridItemBottom>
                <InnerContainer>
                  <TextWrapper>
                    <TitlesContainer>
                      <ImgWrapper>
                        <StyledImg src={prerelease} />
                      </ImgWrapper>
                    </TitlesContainer>
                    <GridItemContent>
                      <GridTitle>
                        Pre-Release <br />
                        Feature Access
                      </GridTitle>
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
              <GridItemBottom>
                <InnerContainer>
                  <TextWrapper>
                    <TitlesContainer>
                      <ImgWrapper>
                        <StyledImg src={validation} />
                      </ImgWrapper>
                    </TitlesContainer>
                    <GridItemContent>
                      <GridTitle>
                        Device <br />
                        Validation
                      </GridTitle>
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
              <GridItemBottom>
                <InnerContainer>
                  <TextWrapper>
                    <TitlesContainer>
                      <ImgWrapper>
                        <StyledImg src={virtual} />
                      </ImgWrapper>
                    </TitlesContainer>
                    <GridItemContent>
                      <GridTitle>
                        Virtual Device Lab
                        <br /> for Canary Testing
                      </GridTitle>
                    </GridItemContent>
                  </TextWrapper>
                </InnerContainer>
              </GridItemBottom>
            </BottomWrapper>
          </GridContainer>
        </SectionOne>
      </div>
    );
  }
}
